var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.users
      ? _c("div", [
          _c("table", { staticClass: "table table-hover" }, [
            _c(
              "tbody",
              [
                _vm.selectAll && _vm.users && _vm.users.length
                  ? [
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAllCheckbox,
                                expression: "selectAllCheckbox",
                              },
                            ],
                            attrs: { type: "checkbox", id: `ch_all` },
                            domProps: {
                              checked: Array.isArray(_vm.selectAllCheckbox)
                                ? _vm._i(_vm.selectAllCheckbox, null) > -1
                                : _vm.selectAllCheckbox,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.selectAllCheckbox,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectAllCheckbox = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectAllCheckbox = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectAllCheckbox = $$c
                                  }
                                },
                                _vm.updateSelect,
                              ],
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("strong", [
                            _c(
                              "label",
                              {
                                staticClass: "pointer",
                                attrs: { for: `ch_all` },
                              },
                              [_vm._v("Выбрать всех курьеров")]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.type == "wPacks"
                  ? _vm._l(this.users, function (runner, index) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "scroll-to",
                              rawName: "v-scroll-to",
                              value: { el: "#id-" + runner.id, offset: -80 },
                              expression:
                                "{ el: '#id-'+runner.id, offset: -80 }",
                            },
                          ],
                          key: index,
                          staticClass: "pointer",
                        },
                        [
                          _c("td"),
                          _vm._v(" "),
                          _c("td", [
                            _c("label", { attrs: { for: `ch_${runner.id}` } }, [
                              _vm._v(_vm._s(runner.name)),
                            ]),
                          ]),
                        ]
                      )
                    })
                  : _vm._l(this.users, function (runner, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selected_runners[runner.id],
                                expression: "selected_runners[runner.id]",
                              },
                            ],
                            attrs: { type: "checkbox", id: `ch_${runner.id}` },
                            domProps: {
                              checked: Array.isArray(
                                _vm.selected_runners[runner.id]
                              )
                                ? _vm._i(
                                    _vm.selected_runners[runner.id],
                                    null
                                  ) > -1
                                : _vm.selected_runners[runner.id],
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selected_runners[runner.id],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selected_runners,
                                        runner.id,
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selected_runners,
                                        runner.id,
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.selected_runners, runner.id, $$c)
                                }
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "label",
                            {
                              staticClass: "pointer",
                              attrs: { for: `ch_${runner.id}` },
                            },
                            [_vm._v(_vm._s(runner.name))]
                          ),
                        ]),
                      ])
                    }),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }